import merge from "deepmerge";
import { green, grey, indigo, red } from "@mui/material/colors";
import { THEMES } from "../constants";

const customBlue = {
  50: "#e9f0fb",
  100: "#c8daf4",
  200: "#a3c1ed",
  300: "#918AFF",
  400: "#918AFF",
  500: "#1180FF",
  600: "#918AFF",
  700: "#1180FF",
  800: "#918AFF",
  900: "#2052c2",
};

// const defaultVariant = {
//   name: THEMES.DEFAULT,
//   palette: {
//     mode: "light",
//     primary: {
//       main: customBlue[700],
//       contrastText: "#FFF",
//     },
//     secondary: {
//       main: customBlue[500],
//       contrastText: "#FFF",
//     },
//     background: {
//       default: "#EBEFF2",
//       paper: "#FFF",
//     },
//   },
//   header: {
//     color: grey[500],
//     background: "#EBEFF2",
//     search: {
//       color: grey[800],
//       background: "#DCE7EF",
//     },
//     indicator: {
//       background: customBlue[600],
//     },
//   },
//   footer: {
//     color: grey[500],
//     background: "#FFF",
//   },
//   sidebar: {
//     color: grey[200],
//     background: "#233044",
//     header: {
//       color: grey[200],
//       background: "#233044",
//       brand: {
//         color: customBlue[500],
//       },
//     },
//     footer: {
//       color: grey[200],
//       background: "#1E2A38",
//       online: {
//         background: green[500],
//       },
//     },
//     badge: {
//       color: "#FFF",
//       background: customBlue[500],
//     },
//   },
// };

let customDefault = {
  50: "#e9f0fb",
  100: "#c8daf4",
  200: "#a3c1ed",
  300: "#918AFF",
  400: "#918AFF",
  500: "#1180FF",
  600: "#918AFF",
  700: "#1180FF",
  800: "#918AFF",
  900: "#2052c2",
};

const defaultVariant = {
  name: THEMES.DEFAULT,
  palette: {
    mode: "light",
    primary: {
      main: customDefault[700],
      contrastText: "#FFF",
    },
    secondary: {
      main: customDefault[700],
      contrastText: "#FFF",
      secondaryText: customDefault[500],
    },
    background: {
      default: "#f9f9f9",
      paper: "#FFF",
    },
  },
  header: {
    color: grey[500],
    background: "#FFF",
    fontColor: "#02121C",
    search: {
      color: grey[800],
      background: "#DCE7EF",
    },
    indicator: {
      background: customDefault[600],
    },
  },
  footer: {
    color: grey[500],
    background: "#FFF",
  },
  sidebar: {
    color: grey[200],
    background: "#282C54",
    header: {
      color: grey[200],
      brand: {
        color: customDefault[500],
      },
    },
    footer: {
      color: grey[200],
      background: "#282C54",
      online: {
        background: green[500],
      },
    },
    badge: {
      color: "#000000",
      background: customDefault[500],
    },
  },
  tableHeader: {
    color: "#2D3152",
    background: "#E5E8EC",
  },
};

const darkVariant = merge(defaultVariant, {
  name: THEMES.DARK,
  palette: {
    mode: "dark",
    primary: {
      main: customBlue[500],
      contrastText: "#FFF",
    },
    secondary: {
      main: customDefault[700],
      contrastText: "#FFF",
      secondaryText: customDefault[500],
    },
    background: {
      default: "#001226",
      paper: "#031A33",
    },
    text: {
      primary: "rgba(255, 255, 255, 0.95)",
      secondary: "rgba(255, 255, 255, 0.5)",
    },
  },
  header: {
    color: grey[300],
    background: "#1E223D",
    search: {
      color: grey[200],
      background: "#1B2635",
    },
  },
  footer: {
    color: grey[300],
    background: "#031A33",
  },
  tableHeader: {
    color: grey[300],
    background: "#02121C",
  },
});

const lightVariant = merge(defaultVariant, {
  name: THEMES.LIGHT,
  palette: {
    mode: "light",
  },
  header: {
    color: grey[500],
    background: "#EBEFF2",
    search: {
      color: grey[800],
    },
    indicator: {
      background: red[700],
    },
  },
  sidebar: {
    color: grey[900],
    background: "#FFF",
    header: {
      color: "#FFF",
      background: customBlue[800],
      brand: {
        color: "#FFFFFF",
      },
    },
    footer: {
      color: grey[800],
      background: "#F7F7F7",
      online: {
        background: green[500],
      },
    },
  },
});

const blueVariant = merge(defaultVariant, {
  name: THEMES.BLUE,
  palette: {
    mode: "light",
  },
  sidebar: {
    color: "#FFF",
    background: customBlue[700],
    header: {
      color: "#FFF",
      background: customBlue[800],
      brand: {
        color: "#FFFFFF",
      },
    },
    footer: {
      color: "#FFF",
      background: customBlue[800],
      online: {
        background: "#FFF",
      },
    },
    badge: {
      color: "#000",
      background: "#FFF",
    },
  },
});

const greenVariant = merge(defaultVariant, {
  name: THEMES.GREEN,
  palette: {
    primary: {
      main: green[800],
      contrastText: "#FFF",
    },
    secondary: {
      main: green[500],
      contrastText: "#FFF",
    },
  },
  header: {
    indicator: {
      background: green[600],
    },
  },
  sidebar: {
    color: "#FFF",
    background: green[700],
    header: {
      color: "#FFF",
      background: green[800],
      brand: {
        color: "#FFFFFF",
      },
    },
    footer: {
      color: "#FFF",
      background: green[800],
      online: {
        background: "#FFF",
      },
    },
    badge: {
      color: "#000",
      background: "#FFF",
    },
  },
});

const indigoVariant = merge(defaultVariant, {
  name: THEMES.INDIGO,
  palette: {
    primary: {
      main: indigo[600],
      contrastText: "#FFF",
    },
    secondary: {
      main: indigo[400],
      contrastText: "#FFF",
    },
  },
  header: {
    indicator: {
      background: indigo[600],
    },
  },
  sidebar: {
    color: "#FFF",
    background: indigo[700],
    header: {
      color: "#FFF",
      background: indigo[800],
      brand: {
        color: "#FFFFFF",
      },
    },
    footer: {
      color: "#FFF",
      background: indigo[800],
      online: {
        background: "#FFF",
      },
    },
    badge: {
      color: "#000",
      background: "#FFF",
    },
  },
});

const variants = [
  defaultVariant,
  darkVariant,
  lightVariant,
  blueVariant,
  greenVariant,
  indigoVariant,
];

export default variants;
